// type不设置默认为success
/**
 * type 主题 string success / warning / info / error
 * duration 显示时间, 毫秒。 设为 0 则不会自动关闭
 * showClose 是否显示关闭按钮
 */
import { Message } from 'element-ui';

export function MESSAGE(params) {
  let obj = {}
  obj.message = params.text
  obj.type = params.type || 'success'
  obj.duration = params.duration || '1000'
  params.showClose && (obj.showClose = params.showClose)
  params.iconClass && (obj.iconClass = params.iconClass)
  Message(obj);
}

